import styles from './TextArea.module.scss'

interface TextAreaProps {
  value: string
  rows?: number
  onInput?: (text: string) => void
  placeholder?: string
  isDisabled?: boolean
  /** Prefer over `isDisabled` for a field the viewer may read but not edit: a disabled textarea
   *  is skipped by screen readers, so the org's own notice becomes unreadable to an AT user. */
  isReadOnly?: boolean
  className?: string
  id?: string
  maxLength?: number
  'aria-label'?: string
  'aria-describedby'?: string
}

const TextArea = (props: TextAreaProps) => {
  const { rows = 4, className, isDisabled, isReadOnly, value, onInput, placeholder, id, maxLength } = props

  return (
    <textarea
      id={id}
      className={`${styles.textArea} ${className ? className : ''}`}
      rows={rows}
      disabled={isDisabled}
      readOnly={isReadOnly}
      value={value}
      onInput={(e) => onInput && onInput(e.currentTarget.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      aria-label={props['aria-label']}
      aria-describedby={props['aria-describedby']}
    />
  )
}

export default TextArea
